module.exports = __webpack_public_path__ + "static/media/3DPPA35.65b79554.jpg";